import Delegate from 'ftdomdelegate';

import { hydrate } from '@/neon/events';
import {
  filtersUpdated,
  removeFilters,
  removeRange,
  clearAll,
  filtersRemoved,
  rangeRemoved,
  everythingCleared,
} from '@/lib/filters/events';

const filterHandler = ({ container, partial, renderCB }) => {
  let subscriptions = null;
  let filters = null;
  let delegate = null;

  import('@/lib/filters/filtering').then(({ default: filtering }) => {
    filters = filtering(container);

    // Set initial evx state from collection url object
    hydrate(filters.getState());

    subscriptions = [
      filtersRemoved((_, { target }) => {
        filters.removeFilters(target, data => {
          renderCB(data.url);
          hydrate(data)();
        });
      }),

      rangeRemoved(() => {
        filters.removeRange(data => {
          renderCB(data.url);
          hydrate(data)();
        });
      }),

      filtersUpdated((_, { target }) => {
        filters.filtersUpdated(target, data => {
          renderCB(data.url);
          hydrate(data)();
        });
      }),

      everythingCleared(() => {
        filters.clearAll(data => {
          renderCB(data.url);
          hydrate(data)();
        });
      }),
    ];

    delegate = new Delegate(partial);

    delegate.on('click', '[data-remove-filter]', e => {
      e.preventDefault();
      removeFilters([e.target]);
    });

    delegate.on('click', '[data-remove-range]', e => {
      e.preventDefault();
      removeRange();
    });


    delegate.on('click', '[data-clear]', e => {
      e.preventDefault();
      clearAll();
      console.log("clear all")
    });
  });

  const unload = () => {
    delegate && delegate.off();
    subscriptions && subscriptions.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
};

export default filterHandler;
